export const SIMULATE_ID = 'start-simulation'
